<template>
  <div>
    <base-card>
      <base-question
        text="Esta categoria possui variedade de bordas?"
        class="mb_25"
      />
      <base-radio
        label="Não"
        family="pizzaEdges"
        class="mb_15"
        :value="showEdgesArea"
        :option="false"
        @click="showEdgesArea = false"
      />
      <base-radio
        label="Sim"
        family="pizzaEdges"
        :value="showEdgesArea"
        :option="true"
        @click="showEdgesArea = true"
      />
    </base-card>
    <div v-if="showEdgesArea">
      <sized-list
        v-if="targetItem.sizes.length > 1"
        title="Quais são as bordas?"
        elementPlaceholder="Nome da borda"
        addButtonText="Adicionar borda"
        :deleteMode="deleteMode.edge"
        :sizes="targetItem.sizes"
        :elements="targetItem.edges.filter((e) => !e.delete)"
        @deleteMode="(activated) => (deleteMode.edge = activated)"
        @removeElement="(e) => deleteItem(e._id, false)"
        @addNewItem="
          () => {
            (deleteMode.edge = false), addEdge();
          }
        "
      />

      <div v-else>
        <base-card>
          <base-question text="Quais são as bordas?" class="mb_25" />

          <div v-if="targetItem.edges.length > 0">
            <div v-for="edge in targetItem.edges" :key="edge._id">
              <div v-if="!edge.delete" class="edge-container">
                <base-input
                  label="Nome da borda"
                  v-model="edge.name"
                  :disabled="deleteMode.edge"
                  class="mb_0 pr_5 pt_0 w-100 mr_10"
                  v-on:change="applyValue(edge._id, 'name', edge.name)"
                  :valid="isValidField('main', 'name')"
                />

                <base-input
                  :type="'tel'"
                  :money-mask="StringLanguage.currencyConfigs"
                  v-model="edge.price"
                  class="mb_0 pt_0 mr_10"
                  design="two"
                />

                <base-button
                  :text="StringLanguage.delete"
                  design="four"
                  @click.prevent="deleteItem(edge._id)"
                  class="delete-button"
                >
                  <i class="fal fa-times"></i>
                </base-button>
              </div>
            </div>
          </div>
          <div class="d-flex justify-end w-100 mt_25">
            <base-button
              text="Adicionar borda"
              design="two"
              @click.prevent="addEdge()"
              class="w-100 mr_5"
            />
          </div>
        </base-card>
      </div>
    </div>
  </div>
</template>

<script>
// components
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseRadio from "@/components/Radio";
import SizedList from "@/containers/Catalog/NewSizedList";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
// libs
import Vue from "vue";
import Builder from "easyjs/lib/Schema/Components/Builder";

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseRadio,
    SizedList,
    BaseInput,
    BaseButton
  },
  data() {
    return {
      deleteMode: {
        edge: false,
      },
      showEdgesArea: this.targetItem.edges.length > 0,
    };
  },
  props: {
    targetItem: { default: {} },
  },
  methods: {
    addEdge() {
      if (this.targetItem.sizes.filter((i) => !i.delete).length > 0) {
        this.addNewItem("Edge", this.targetItem._id);
        this.updateEdges();
      } else {
        alert("Você precisa cadastrar algum tamanho antes.");
      }
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    updateEdges() {
      this.targetItem.edges.forEach((e) => {
        let edgeSizes = e.sizes.reduce(
          (obj, size) => ({ ...obj, [size._id]: size }),
          {}
        );
        e.sizes = this.targetItem.sizes
          .map((s) => {
            return edgeSizes[s._id] || Builder.mountSchema(Object.clone(s));
          })
          .filter((s) => !s.delete);
      });
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam("_id", id)
            .forEach((i) => Vue.set(i, "delete", true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory("Catalog");
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, (item) => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                "sizes",
                item.sizes.filter((s) => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, (res) => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit("saveItem", this.targetItem);
      }
    },
    applyValue(sizeId, attr, max) {},
    isValidField(key, value) {},
  },
};
</script>

<style scoped>
.edge-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}
.delete-button {
  height: 45px;
  margin-left: 5px;
  border-color: #99999980;
}
.delete-button i {
  font-size: 16px;
}
</style>